/*
 * @Author: Teemo Ding
 * @Date: 2021-09-07 17:08:19
 * @LastEditors: Teemo Ding
 * @LastEditTime: 2022-03-09 14:02:36
 * @FilePath: /unifyxp-v2-store-portal/src/request/salesChannel/discounts/directDiscount.ts
 */
import { post, get } from 'src/tools/server';

export const saveDirectDiscount = (data, params?) => {
  return post<any>(`/portal/discount/direct`, data || {}, {
    returnWholeData: true,
    handleErrorAsResolve: true,
    ...(params || {}),
  });
};

export const getDirectDiscount = (salesChannelUuid, params?) => {
  return get<any>(`/portal/${salesChannelUuid}/discountPage`, params || {});
};

export const getDirectDiscountList = (data, startIndex, batchSize) => {
  return post<any>(`/portal/discounts/${startIndex}/${batchSize}`, data, {});
};

export const getDeliveryMethods = (salesChannelUuid, params?) => {
  return get<any>(
    `/portal/salesChannelDeliveryMethods/${salesChannelUuid}`,
    params || {},
  );
};
